import { addressLink } from "src/utils/network"
import LinkExplorerIcon from "../../assets/images/link_explorer.svg"

type Props = {
  chainId: number
  address: string
}

export const LinkExplorer: React.FC<Props> = ({ chainId, address }) => {
  return (
    <a href={addressLink(chainId, address)} target="_blank" rel="noreferrer">
      <img src={LinkExplorerIcon} alt="link to explorer" className="w-6 h-6" />
    </a>
  )
}